import o, { css as e } from "styled-components";
import { Checkbox as a } from "../../Option/Checkbox.es.js";
import { Image as r } from "../../../DataDisplay/Image/Image.es.js";
import { Icon as i } from "../../../DataDisplay/Icon/Icon.es.js";
import { Input as p } from "../../Input/Input.es.js";
const f = o(r).withConfig({
  displayName: "SingleValueImage",
  componentId: "sc-ox8fd5-0"
})(["border:1px solid var(--color-components-input-border-default);border-radius:var(--size-border-radius-sm);height:24px;margin-left:4px;margin-right:8px;object-fit:contain;padding:4px;width:44px;"]), g = o.div.withConfig({
  displayName: "ActionButtons",
  componentId: "sc-ox8fd5-1"
})(["border-top:1px solid var(--color-components-input-border-default);display:flex;gap:8px;justify-content:flex-end;padding:8px 12px;"]), x = o.div.withConfig({
  displayName: "SearchInput",
  componentId: "sc-ox8fd5-2"
})(["position:relative;", ""], ({
  hasMenuSearch: t
}) => !t && e(["height:0;opacity:0;width:0;"])), h = o.div.withConfig({
  displayName: "SearchInputIcons",
  componentId: "sc-ox8fd5-3"
})(["align-items:center;color:var(--color-components-input-border-strong);display:flex;gap:var(--size-gap-4);position:absolute;right:var(--size-gap-24);top:50%;transform:translateY(-50%);"]), u = o(i).withConfig({
  displayName: "SearchInputIconSearch",
  componentId: "sc-ox8fd5-4"
})(["color:var(--color-components-button-secondary-text-bg);"]);
o(i).withConfig({
  displayName: "SearchInputIconLoading",
  componentId: "sc-ox8fd5-5"
})([""]);
const I = o(p).withConfig({
  displayName: "SearchInputField",
  componentId: "sc-ox8fd5-6"
})(["border-bottom:1px solid var(--color-components-input-border-default);padding:12px;"]);
o.input.withConfig({
  displayName: "OptionEditInput",
  componentId: "sc-ox8fd5-7"
})(["border:none;border-bottom:1px solid var(--color-border-default);outline:none;width:100%;"]);
const b = o.div.withConfig({
  displayName: "CreateLabel",
  componentId: "sc-ox8fd5-8"
})(["display:flex;flex-direction:column;gap:var(--size-2);"]), y = o.div.withConfig({
  displayName: "LeftWrapper",
  componentId: "sc-ox8fd5-9"
})(["align-items:center;display:flex;gap:var(--size-6);justify-content:center;"]), v = o.div.withConfig({
  displayName: "OptionLabel",
  componentId: "sc-ox8fd5-10"
})(["overflow:hidden;span{display:block;}"]);
var n;
const w = o.div.withConfig({
  displayName: "Option",
  componentId: "sc-ox8fd5-11"
})(["align-items:center;display:flex;gap:var(--size-6);max-width:100%;overflow:hidden;", "{z-index:1;}", " @keyframes slideText{0%{transform:translateX(0%);}100%{transform:translateX(-100%);}}"], (n = a.S) == null ? void 0 : n.Input, ({
  hasSlideAnimation: t
}) => t && e(["&:hover{span{animation:slideText 5s linear infinite;}}"]));
export {
  g as ActionButtons,
  b as CreateLabel,
  y as LeftWrapper,
  w as Option,
  v as OptionLabel,
  x as SearchInput,
  I as SearchInputField,
  u as SearchInputIconSearch,
  h as SearchInputIcons,
  f as SingleValueImage
};
//# sourceMappingURL=style.es.js.map
